import { combinedEpics, combinedReducers } from "./rootReducer"
import { StockDocumentAction } from "./stockdocument/actions"
import { StockDocumentSelector } from "./stockdocument/selectors"

export const inventoryReducer = combinedReducers
export const inventoryEpics = combinedEpics

export * from "./stockDocumentDefinition"

export const InventoryStockDocumentAction = StockDocumentAction
export const InventoryStockDocumentSelector = StockDocumentSelector



// WEBPACK FOOTER //
// ./src/state/inventory/index.ts